import { useQuery } from "react-query";
import { fetchWorkspaces } from "@/services/workspaces";
/** Query hook for the current user's permitted workspace list. */
export function useWorkspaces() {
  return useQuery(["workspaces"], function () {
    return fetchWorkspaces();
  }, {
    staleTime: Infinity,
    cacheTime: Infinity
  });
}